import { TFilters } from '../types';

export const initialFilters: TFilters = {
  serviceBook: '',
  serviceBookId: 0,
  name: '',
  role: '',
};

export const scOpensText = 'The Service Center opens at';
export const scClosesText = 'The Service Center closes at';
